import fnMedian from 'frontend-utils/utils/numeric/find-median';

/**
 * Calculates the median for a set of values
 * Expects values as an array of numbers like:
 * [94, 94, 134, 58.65, 102]
 * Returns undefined for any NaN situation
 *
 * @param  {Array} values   Array of floating-point values
 * @return {Number}         The median for the set of numbers, or undefined if no valid median exists
 */
export default function findMedianRate(values: number[]): number | undefined {
  const median = fnMedian(values);
  return Number.isNaN(median) ? undefined : median;
}
